$(document).on("ready turbolinks:load", function() {
  $("#filtersBtn").on("click", () => {
    $("#show").toggle();
    $("#hide").toggle();
    $("#filters").slideToggle();
  });
});
